module.exports = __webpack_public_path__ + "img/health.25732006.svg";